import useResource from "./useResource"

export default function useFindComparableDealsView({ deal }) {
  const key = `deals/${deal.id}/sales/available_deals/view`
  return useResource({ key })
}
